import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

export default class Gnav {
	constructor(el) {
		this.el = document.querySelector(el);

		this.html = document.querySelector('html');
		this.mq = window.matchMedia(`(min-width: 768px)`);
		this.offsetY = window.scrollY;
		this.trigger = null;
		this.target = null;

		this.accordionTriggers = null;
		this.accordionTargets = [];
		this._isAccordionAnimation = false;

		this._init = this._init.bind(this);

		this._init();

		this._watch = this._watch.bind(this);
	}

	_init() {
		if (!this.el) {
			return;
		}
		//console.log('gnab');

		setTimeout(() => {
			this.html.classList.add('scroll-behavior');
		}, 100);

		this._watch();
		//this._accordion();
	}

	_watch() {
		const offset = window.scrollY;
		if (offset > 300) {
			this.el.classList.add('is-scrolled');
		} else {
			this.el.classList.remove('is-scrolled');
		}

		window.requestAnimationFrame(this._watch.bind(this));
	}

	gnav(gnavTrigger) {
		this.trigger = document.querySelector(gnavTrigger);
		this.target = document.getElementById(this.trigger.getAttribute('aria-controls'));

		if (!this.trigger || !this.target) {
			return;
		}

		this.trigger.addEventListener('click', (e) => {
			e.preventDefault();
			//console.log('click');

			if (e.currentTarget.getAttribute('aria-expanded') === 'true') {
				e.currentTarget.setAttribute('aria-expanded', 'false');

				this._close();
				this.html.classList.add('scroll-behavior');
				this.target.setAttribute('hidden', true);
			} else {
				this.html.classList.remove('scroll-behavior');
				e.currentTarget.setAttribute('aria-expanded', 'true');
				this.offsetY = window.scrollY;
				//this.html.style.top = `-${this.offsetY}px`;
				this.html.classList.add('js-gnav-open');
				this.target.removeAttribute('hidden');
				//this.target.classList.add('js-gnavi-open');

				this._actionWhenOpen();
			}
		});

		// this.mq.addEventListener('change', this._closeWhenMd.bind(this));
		// this._closeWhenMd(this.mq);
	}

	accordion(accordionTriggers, gnavContainer) {
		this.accordionTriggers = this.el.querySelectorAll(accordionTriggers);
		this.gnavContainer = this.el.querySelector(gnavContainer);
		//console.log(this.accordionTriggers);

		this.mqDesktop = window.matchMedia('(min-width: 768px)');
		this.mqMobile = window.matchMedia('(max-width: 767px)');

		this._handleMqChange = this._closeWhenMd.bind(this);
		this.mqDesktop.addEventListener('change', this._handleMqChange);

		this.accordionTriggers.forEach((accTrigger) => {
			//console.log('!!');
			const accBody = document.getElementById(accTrigger.getAttribute('aria-controls'));
			//console.log(accBody);
			accBody.style.height = '0px';
			this.accordionTargets.push(accBody);

			//let animation;
			//console.log(accTrigger.getAttribute('aria-expanded') === 'true');

			accTrigger.addEventListener('click', (e) => {
				// if (animation) {
				// 	return;
				// }

				if (this._isAccordionAnimation) {
					return;
				}
				this._isAccordionAnimation = true;

				const isDesktop = this.mqDesktop.matches;
				const isMobile = this.mqMobile.matches;

				const expanded = accTrigger.getAttribute('aria-expanded') === 'true';
				accTrigger.setAttribute('aria-expanded', String(!expanded));

				if (isDesktop) {
					//console.log('isdesctop');
					this.accordionTargets.forEach((target) => {
						if (target !== accBody) {
							gsap.to(target, {
								height: 0,
								duration: 0.25,
								//clearProps: 'height',
								onComplete: () => {
									//animation = false;
									document.getElementById(target.getAttribute('aria-labelledby')).setAttribute('aria-expanded', 'false');

									target.hidden = true;
								},
							});
						}
					});
				}

				if (expanded) {
					gsap.to(accBody, {
						height: 0,
						duration: 0.25,
						//clearProps: 'height',
						onComplete: () => {
							this._isAccordionAnimation = false;
							accBody.hidden = expanded;
							//accBody.style.height = '0px';
						},
					});
				} else {
					accBody.hidden = expanded;

					gsap.to(accBody, {
						height: isDesktop ? '100%' : 'auto',
						//height: 'auto',
						duration: 0.5,
						onComplete: () => {
							this._isAccordionAnimation = false;

							if (!isDesktop) {
								// requestAnimationFrame(() => {
								// 	accTrigger.scrollIntoView({
								// 		behavior: 'smooth',
								// 		block: 'start',
								// 	});
								// });

								gsap.to(this.gnavContainer, {
									scrollTo: {
										y: accTrigger,
										offsetY: 80,
									},
									duration: 0.25,
								});
							}
						},
					});

					//setTimeout(() => {

					// mm.add(

					// 	(context) => {
					// 		const { isDesktop, isMobile } = context.conditions;

					// 	},
					// );
					//}, 1000);

					// gsap.to(accBody, {
					// 	height: 'auto',
					// 	duration: 0.25,
					// 	onComplete: () => {
					// 		this._isAccordionAnimation = false;
					// 	},
					// });
				}
			});
		});
	}

	_closeWhenMd(e) {
		this._actionWhenOpen();

		//if (e.matches) {
		// this.target.removeAttribute('hidden');
		// this._close();
		//}
	}

	_close() {
		this.html.classList.remove('js-gnav-open');
		// this.html.style.removeProperty('top');
		// window.scrollTo(0, this.offsetY);
		this.trigger.setAttribute('aria-expanded', 'false');
		//this.html.classList.add('scroll-behavior');
	}

	_actionWhenOpen() {
		this.accordionTriggers?.forEach((accTrigger) => {
			//console.log('!!');
			const accBody = document.getElementById(accTrigger.getAttribute('aria-controls'));

			if (window.innerWidth > 769) {
				if (accTrigger.id === 'gnav-about-id') {
					accTrigger.setAttribute('aria-expanded', String(true));
					accBody.hidden = false;
					//accBody.removeAttribute('style');
					accBody.style.height = 'auto';
				} else {
					accTrigger.setAttribute('aria-expanded', String(false));
					accBody.hidden = true;
					//accBody.removeAttribute('style');
					accBody.style.height = '0px';
				}
			} else {
				accTrigger.setAttribute('aria-expanded', String(false));
				accBody.hidden = true;
				//accBody.removeAttribute('style');
				accBody.style.height = '0px';
			}

			//console.log(accBody);
		});
	}

	toggleSearch(search) {
		this.search = this.el.querySelector(search);
		//console.log(this.search);

		if (!this.search) {
			return;
		}

		this.searchFormToggleTrigger = this.search.querySelector('.js-gnav-search__trigger');
		this.searchFormToggleForm = this.search.querySelector('.js-gnav-search__form-wrap');
		//console.log(this.searchFormToggleTrigger, this.searchFormToggleForm);

		this.searchFormToggleTrigger?.addEventListener('click', (e) => {
			//console.log(e);
			console.log(this.searchFormToggleForm);
			this.searchFormToggleForm.querySelector('.input-text').focus();
			const expanded = this.searchFormToggleTrigger.getAttribute('aria-expanded') === 'true';
			this.searchFormToggleTrigger.setAttribute('aria-expanded', String(!expanded));

			this.searchFormToggleForm.hidden = expanded;
		});
	}
}
